import { render, staticRenderFns } from "./FollowUpTemplateForm.vue?vue&type=template&id=d72a0788&scoped=true&"
import script from "./FollowUpTemplateForm.vue?vue&type=script&lang=js&"
export * from "./FollowUpTemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpTemplateForm.vue?vue&type=style&index=0&id=d72a0788&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72a0788",
  null
  
)

export default component.exports